import { createContext } from "react";
import { CurrentUserProtectionTokenFragment } from "gql/graphql";

export type ContextProps = {
  tokens: CurrentUserProtectionTokenFragment[];
};

export const UserProtectionTokensContext = createContext<ContextProps>({
  tokens: [],
});
